<template>
  <div id="mobile">
    <router-view class="mobile-header" name='header'></router-view>
    <router-view class="mobile-router" name='routing'></router-view>
    <router-view class="mobile-sidebarm" name='sidebarm'></router-view>
    <!--<router-view class="mobile-sponsors" name='sponsors'></router-view>-->
  </div>
</template>
<script>
  export default{
    name: 'mobile'
  }
</script>
<style>
  #mobile {
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  #mobile > .mobile-header {
    flex: 0 0 40px;
    order: 1;
  }

  #mobile > .mobile-router {
    flex: 0 0 50px;
    order: 2;
  }

  #mobile > .mobile-sidebarm {
    flex: 1;
    order: 3;
  }

  #mobile > .mobile-sponsors {
    flex: 0 0 50px;
    order: 4;
  }
</style>



// WEBPACK FOOTER //
// src/components/mobile.vue